
import type { AppLoader } from '@zto/zpage'

import { IAMAuthLoader } from './iam-auth-loader'

export const loaders: AppLoader[] = [IAMAuthLoader]
